<template>
    <div>
        <div
            class="monito-cards-container"
        >
            <div
                v-for="slot in channelsSlots"
                :key="slot.position"
                :class="slot.channel === null ? 'no-channel-card' : 'monito-channel-card'"
            >
                <div v-if="slot.channel === null" class="no-channel"></div>
                <div
                    v-else
                    @click="goToSelectedChannel(slot.channel,'details')"
                >
                    <channel-overview-card
                        :channel-supervision="slot.channel"
                        :schedulings="getChannelSchedulings(slot.channel)"
                        @openChannelConfiguration="openChannelConfiguration"
                    ></channel-overview-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChannelOverviewCard from './channel-overview-card.vue';
export default {

    name: 'channel-overview-page',
    components:{
        ChannelOverviewCard
    },
    props:{
        channelsToDisplay:{
            type: Array,
            required: true
        },
        schedulings:{
            type: Array,
            required: true
        },
    },
    data () {
        return {
            channelsSlots: [
                {
                    position: 1,
                    channel: null,
                },
                {
                    position: 2,
                    channel: null,
                },
                {
                    position: 3,
                    channel: null,
                },
                {
                    position: 4,
                    channel: null,
                },
                {
                    position: 5,
                    channel: null,
                },
                {
                    position: 6,
                    channel: null,
                },
                {
                    position: 7,
                    channel: null,
                },
                {
                    position: 8,
                    channel: null,
                },
            ],
        };
    },
    mounted(){
        this.channelsSlots.map((slot, index) => {
            this.channelsToDisplay.map(supervision => {
                if(supervision.channel.overview_page_position === slot.position){
                    this.$set(this.channelsSlots[index], 'channel', supervision);
                }
            });
        });
    },
    methods:{
        goToSelectedChannel(channel, tab, taker=null){
            this.$router.push({
                name: 'channels',
                params: { channelUid: channel.channel.uid, tab:tab, takerUid:taker?taker.uid:taker}
            });
        },
        openChannelConfiguration(data){
            this.goToSelectedChannel(data.channel, data.tab, data.taker);
        },
        getChannelSchedulings(channel){
            return this.schedulings.filter(scheduling => scheduling.channel_uid === channel.channel_uid);
        }
    }
};
</script>

<style lang="css" scoped>
.monito-cards-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.monito-channel-card{
    padding: 22px 15px;
    background-color: #292B30;
    border-radius: 5px;
    width: 49%;
    justify-content: space-between;
    margin-bottom: 15px;
    margin-top: 22px;
    cursor: pointer;
}
.no-channel-card{
    padding: 25px 20px;
    width: 49%;
    margin-bottom: 15px;
    margin-top: 22px;
    height: 10em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ChannelsOverview/channel-overview-page.vue